import React from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface StarbucksCardDisplayProps {
  balance: number;
}

export default function StarbucksCardDisplay({ balance }: StarbucksCardDisplayProps) {
  return (
    <div className="starbucks-card-gradient rounded-3xl p-5 card-shadow-lg relative overflow-hidden">
      {/* Card pattern */}
      <div className="absolute top-0 right-0 w-40 h-40 rounded-full bg-white/5 -translate-y-10 translate-x-10" />
      <div className="absolute bottom-0 left-0 w-32 h-32 rounded-full bg-white/5 translate-y-8 -translate-x-8" />

      {/* Logo */}
      <div className="flex items-center justify-between mb-6 relative z-10">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center overflow-hidden">
            <AppImage src="/assets/images/gloria_jeans_logo.png" alt="Gloria Jean's logo" width={32} height={32} className="w-full h-full object-contain" />
          </div>
          <span className="text-white font-bold text-sm">Gloria Jean's Card</span>
        </div>
        <div className="flex gap-1">
          <div className="w-6 h-6 rounded-full bg-white/30" />
          <div className="w-6 h-6 rounded-full bg-white/20 -ml-2" />
        </div>
      </div>

      {/* Balance */}
      <div className="relative z-10 mb-4">
        <p className="text-white/60 text-xs font-medium mb-1">Kart Bakiyesi</p>
        <p className="text-white font-black text-4xl font-tabular">
          ₺{balance.toFixed(2).replace('.', ',')}
        </p>
      </div>

      {/* Card number */}
      <div className="flex items-center justify-between relative z-10">
        <p className="text-white/60 text-sm font-mono tracking-widest">
          **** **** 1234
        </p>
        <div className="flex items-center gap-1">
          <Icon name="ShieldCheckIcon" size={14} className="text-white/60" />
          <span className="text-white/60 text-xs">Güvenli</span>
        </div>
      </div>
    </div>
  );
}